import Swiper from 'swiper/bundle';

$('.pattern-related-news').each(function () {
  const self = $(this);
  const swiperContainer = self.find('.swiper');

  if (swiperContainer.length === 0) return;

  const carouselId = swiperContainer.attr('class').split(' ')[1];

  new Swiper('.' + carouselId, {
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
});
